import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, MoreVertical, Sparkles } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '../../components/ui/DropdownMenu';
import { riveCollections } from '../../src/seed';
export function RiveCollections() {
  const navigate = useNavigate();
  return <div className="space-y-6" data-id="element-590">
      <div className="flex items-center justify-between" data-id="element-591">
        <div data-id="element-592">
          <h1 className="text-3xl font-bold tracking-tight" data-id="element-593">Collections</h1>
          <p className="text-muted-foreground" data-id="element-594">
            Curated groups of Rive animations for patient education and clinical
            training
          </p>
        </div>
        <Button data-id="element-595">
          <Plus className="mr-2 h-4 w-4" data-id="element-596" />
          New collection
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-597">
        {riveCollections.map(collection => <Card key={collection.id} className="cursor-pointer hover:shadow-md transition-shadow group relative" onClick={() => navigate(`/rive/collections/${collection.id}`)} data-id="element-598">
            <CardHeader className="pb-3" data-id="element-599">
              <div className="flex items-start justify-between" data-id="element-600">
                <div data-id="element-601">
                  <CardTitle className="text-lg" data-id="element-602">{collection.name}</CardTitle>
                  <div className="flex items-center gap-2 mt-1.5" data-id="element-603">
                    <Badge variant="secondary" data-id="element-604">Manual</Badge>
                    <CardDescription className="m-0" data-id="element-605">
                      {collection.itemCount} files
                    </CardDescription>
                  </div>
                </div>
                <DropdownMenu data-id="element-606">
                  <DropdownMenuTrigger asChild onClick={e => e.stopPropagation()} data-id="element-607">
                    <Button variant="ghost" size="icon" className="h-8 w-8 -mr-2 -mt-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-608">
                      <MoreVertical className="h-4 w-4" data-id="element-609" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" data-id="element-610">
                    <DropdownMenuItem onClick={e => e.stopPropagation()} data-id="element-611">
                      Edit
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={e => e.stopPropagation()} className="text-destructive" data-id="element-612">
                      Delete
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            </CardHeader>
            <CardContent data-id="element-613">
              <p className="text-sm text-muted-foreground mb-4 line-clamp-2 h-10" data-id="element-614">
                {collection.description}
              </p>
              <div className="flex gap-2" data-id="element-615">
                <div className="size-12 rounded-md bg-muted/60 flex items-center justify-center" data-id="element-616">
                  <Sparkles className="h-5 w-5 text-muted-foreground/40" data-id="element-617" />
                </div>
                <div className="size-12 rounded-md bg-muted/60 flex items-center justify-center" data-id="element-618">
                  <Sparkles className="h-5 w-5 text-muted-foreground/40" data-id="element-619" />
                </div>
                <div className="size-12 rounded-md bg-muted/60 flex items-center justify-center" data-id="element-620">
                  <Sparkles className="h-5 w-5 text-muted-foreground/40" data-id="element-621" />
                </div>
              </div>
            </CardContent>
          </Card>)}
      </div>
    </div>;
}